import { FC, ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';
import { ModalWrapper } from '../../../../components/modal-wrapper/index';

type ConfirmDeleteModalProps = {
  body: ReactNode;
  isOpen: boolean;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: ReactNode;
};

// The one confirmation every delete in the Data Room asks for — a space, a folder or a file.
export const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = ({
  body,
  isOpen,
  isPending,
  onCancel,
  onConfirm,
  title,
}) => {
  // A response arriving after a dismissal could close whichever modal was opened since.
  const cancel = () => {
    if (!isPending) {
      onCancel();
    }
  };

  return (
    <ModalWrapper
      className="w-full max-w-[485px] shadow-none"
      control={{ onOpenChange: (open) => !open && cancel(), open: isOpen }}
      onBgClick={cancel}
      side="CENTER"
    >
      <div className="flex w-full flex-col gap-6 rounded-lg bg-white p-6 shadow-3xl">
        <h2 className="text-xl font-[550] text-gray-700">{title}</h2>
        <p className="break-words text-xs font-[450] leading-[18px] text-gray-500">{body}</p>
        <div className="flex items-center justify-end gap-3">
          <Button
            className="h-11 w-fit border border-gray-300 px-6 text-sm font-[450] text-gray-700"
            disabled={isPending}
            onClick={cancel}
            styleType="DEFAULT_ROUNDED"
          >
            <AppFormattedMessage id="CANCEL" />
          </Button>
          <Button
            className="h-11 w-fit bg-fireside-600 px-6 hover:bg-fireside-700"
            disabled={isPending}
            isLoading={isPending}
            onClick={onConfirm}
          >
            <AppFormattedMessage id="DELETE" />
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};
